import $ from 'jquery';
import { connectLazyComponent } from "@lts-web/utils/ComponentUtil";

export default (loader, extendedClassFn) => (
    function (selector, props, context) {
        const element = $(selector).get(0);

        return {
            connectedCallback () {
                $(element).removeComponent();

                connectLazyComponent(
                    element,
                    props,
                    context,
                    loader,
                    extendedClassFn
                );
            }
        };
    }
);